import { ROUTE_GROUPS, ROUTE_NAMES } from '@atlassian/jira-common-constants/src/spa-routes';

export const globalSettingsPerformanceOverviewRoute = {
	group: ROUTE_GROUPS.GLOBAL_SETTINGS,
	name: ROUTE_NAMES.GLOBAL_SETTINGS_PERFORMANCE_OVERVIEW,
	path: '/jira/settings/system/performance/overview',
};

export const globalSettingsPerformanceMetricDetailRoute = {
	group: ROUTE_GROUPS.GLOBAL_SETTINGS,
	name: ROUTE_NAMES.GLOBAL_SETTINGS_PERFORMANCE_METRIC_DETAIL,
	path: '/jira/settings/system/performance/metric/:metricKey',
};
